<template>
	<div>
		<el-row>
		  	<el-col :span="24">
				<h2>
					<img :src="icon" alt="" style="width: 32px; height: 32px; display: inline-block; vertical-align: middle;">
					{{displayName}}
				</h2>
				<el-form :rules="rules" ref="form" :model="form">
					<el-row type="flex" justify="left" :gutter="40">
					  	<el-col :span="8">
							<el-form-item label="Тип стоимости" prop="priceType">
								<div style="clear: left;"><el-switch v-model="recipe.priceType" active-text="По рецепту" inactive-text="Произвольная" active-value="recipePrice" inactive-value="customPrice" active-color="#13ce66" inactive-color="#409EFF"></el-switch></div>
							</el-form-item>	
							<el-form-item v-if="recipe.priceType == 'customPrice'" label="Стоимость">
							  	<el-input-number v-model="recipe.customPrice" :precision="1" :min="0" placeholder="Укажите стоимость" style="width: 100%;"></el-input-number>
							</el-form-item>
							<el-form-item v-if="recipe.priceType == 'recipePrice'" label="Стоимость">
							  	<el-input-number v-model="recipe.recipePrice" :precision="1" :min="0" :disabled="true" style="width: 100%;"></el-input-number>
							</el-form-item>
						</el-col>
					  	<el-col :span="16">  	
					  		<el-row type="flex" justify="left" :gutter="40">
							  	<el-col :span="5" v-if="recipe.priceType == 'recipePrice'">
							  		<el-row style="margin-bottom: 16px;"> 
							  			<el-col :span="24"><h2>Схема рецепта</h2></el-col>
							  		</el-row> 
							  		<el-row v-for="i in 3" style="margin-bottom: 16px;">
							  			<el-col :span="8" v-for="j in 3">
											<img :src="icons[(i-1)*3+(j-1)]" alt="" style="width: 32px; height: 32px; display: inline-block; vertical-align: middle; border: 1px solid; background-color: rgba(0,0,0,.1);">
							  			</el-col>
							  		</el-row>
							  	</el-col>
							  	<el-col :span="19">
								  	<div v-if="visibilityImportButton">
								  		<p v-if="importRecipeGroup.length == 0">Рецепт отсутствует в базе? Попробуйте позаимствовать его у других пользователей.</p>
								  		<el-button size="mini" @click="importRecipe" v-if="importRecipeGroup.length == 0">Импортировать</el-button>
								  		<el-table :data="importRecipeGroup" border ref="importCollection" :default-sort = "{prop: 'rating', order: 'descending'}" v-if="importRecipeGroup.length > 0" max-height="200">
								  			<el-table-column label="Рейтинг" prop="rating" sortable sort-by="rating">
									  			<template slot-scope="scope">
										        	<span>{{scope.row.rating}}</span>
										      	</template>
									    	</el-table-column>
									    	<el-table-column label="Действие" prop="event" align="right" width="120">
										    	<template slot="header" slot-scope="scope">
								  					<el-button size="mini" @click="importRecipe" v-if="importHaveNextPage">Добавить</el-button>
											    </template>
									    		<template slot-scope="scope">
										        	<el-button size="mini" @click="changeRecipeOnImport(scope.row)">Применить</el-button>
										      	</template>
									    	</el-table-column>
								  		</el-table>
								  		<p v-if="noImportRecipes">Этот рецепт ещё не добавлен пользователями, добавь его первым!</p>
								  	</div>
							  	</el-col>
							</el-row>
					  	</el-col>
					</el-row>
					<h2 v-if="recipe.priceType == 'recipePrice'">Рецепт</h2>
					<el-row type="flex" justify="left">
					  	<el-col :span="24">
					  		<el-row v-for="i in 3" :gutter="40">
					  			<el-col :span="8" v-for="j in 3">
									<el-form-item v-if="recipe.priceType == 'recipePrice'" :label="'Слот ' + ((i-1)*3+j)" ref="ingredient">
										<el-image :src="icons[(i-1)*3+(j-1)]" style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 10px;"><div slot="error" class="image-slot"></div></el-image>
										<span style="display: inline-block; vertical-align: middle; margin-right: 15px;">{{prices[(i-1)*3+(j-1)]}}</span>
										<el-button v-if="params[(i-1)*3+(j-1)]" size="mini" @click="editItem(params[(i-1)*3+(j-1)])">Редактировать</el-button>
										<el-button v-if="params[(i-1)*3+(j-1)] == false" size="mini" @click="addNewItem((i-1)*3+(j-1))">Добавить</el-button>
										<el-button style="float: right;" v-if="ingredients[(i-1)*3+(j-1)] == '' && lastpick != ''" size="mini" @click="duplicate((i-1)*3+(j-1))">Повторить</el-button>
									    <el-select @change="changeIngredient" v-model="ingredients[(i-1)*3+(j-1)]" :clearable="true" filterable remote placeholder="Напишите наименование" :remote-method="remoteMethod" :loading="loading" style="width: 100%;">
									    	<el-option-group v-for="group in options" :label="group.label">
										    	<el-option v-for="item in group.options" :label="item.displayName" :value="item.name">
										    		<el-image style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 5px;" :src="item.image"></el-image>
										    		<span style="display: inline-block; vertical-align: middle; margin-right: 10px;">{{item.displayName}}</span>
										    		<el-button size="mini" @click.stop="addItemToFilter(item.name)" :icon="'el-icon-'+item.filterIcon" style="float: right;"></el-button>
										    	</el-option>
										    </el-option-group>	
									  	</el-select>
									</el-form-item>
					  			</el-col>
					  		</el-row>
					  	</el-col>	
					</el-row>
				  	<el-row :gutter="40">
				  		<el-col :span="8">
							<el-form-item v-if="recipe.priceType == 'recipePrice'" label="Количество продукта" prop="count">
							  	<el-input-number @change="changeIngredient()" v-model="recipe.count" :precision="1" :min="0.1" :max="9999" style="width: 100%;"></el-input-number>
							</el-form-item>
				  		</el-col>
				  		<el-col :span="8">
							<el-form-item v-if="recipe.priceType == 'recipePrice'" label="Модификации ингредиентов" prop="mod">
							    <el-select v-model="currentMods" placeholder="Выберите модификации ингредиентов" multiple style="width: 100%" @remove-tag="removeMod">
							    	<el-option v-for="item in filters" :value="item.value" :label="item.label">
							    		<span>{{item.label}}</span>
							    	</el-option>
							  	</el-select>
							</el-form-item>
				  		</el-col>
				  		<el-col :span="8">
							<el-form-item v-if="recipe.priceType == 'recipePrice'" label="Фильтр ингредиентов" prop="itemsFilter">
								<div style="clear: left;"><el-switch v-model="itemsFilterVisibility" active-text="Включен" inactive-text="Выключен" :active-value="true" :inactive-value="false" active-color="#13ce66" inactive-color="#409EFF"></el-switch></div>
							</el-form-item>
				  		</el-col>
				  	</el-row> 
					<el-form-item>
					    <el-button :type="submitType" @click="submitForm('form')">Сохранить</el-button>
					    <el-button type="danger" @click="removeItem(recipe.mod, recipe.item); $router.replace('/items');">Удалить</el-button>
				  		<el-tooltip class="item" effect="dark" content="Если Вы заметили явную ошибку в рецепте по умолчанию и знаете правильный рецепт предмета (не обычную разновидность рецепта, а именно корректный рецепт аналогичный текущему), пожалуйста настройте корректный рецепт в своей коллекции, сохраните его и нажмите на эту кнопку" placement="top-start" v-if="recipe.priceType == 'recipePrice'">
					      	<el-button @click="suggestRecipe">Предложить рецепт</el-button>
					    </el-tooltip>
					    <!-- <el-upload :on-change="fileChange" action="https://jsonplaceholder.typicode.com/posts/" list-type="picture">
						  	<el-button size="small" type="primary">Импорт рецепта из NEI</el-button>
						</el-upload> -->
						<canvas id="recipe-canvas" height="100" width="100" style="display:none;"></canvas>
						<!-- <img :src="source" alt="" id ="source"> -->
					</el-form-item>
				</el-form>
				<el-button size="mini" @click="back">Назад</el-button>
				<div v-if="parentList.length > 0">
					<p>&nbsp;</p>
					<h2>Этот предмет встречается в крафте ({{parentList.length}}):</h2>
					<p>
						<a href="#" v-for="item in parentList" @click.prevent="editItem({name: 'edit item', params: {item: item.item}});"><img :src="item.image" :alt="item.displayName" :title="item.displayName" style="width: 32px; height: 32px; display: inline-block; vertical-align: middle; margin: 0 10px 10px 0;"></a>
					</p>
				</div>	
		  		<!-- <p>Recipe:</p>
		  		<pre><code>{{ JSON.stringify(recipe, null, 2) }}</code></pre> -->
		  	</el-col>
		</el-row>
		<hr>
		<el-row>
			<el-col>
				<p>На этой странице выводятся настройки предмета из коллекции. При добавлении предмета в коллекцию его стоимость выставлена по умолчанию как 0. Вы можете изменить стоимость предмета по умолчанию в поле "Стоимость". Для сохранения изменений в настройках предмета нажмите на кнопку "Сохранить". После успешного сохранения кнопка поменяет цвет на зелёный. Для удаления предмета из коллекции нажмите на кнопку "Удалить". После удаления предмета вы будете переадресованы на страницу коллекции. Для того чтобы настроить расчёт стоимости предмета, исходя из его рецепта, переключите нажатием тумблер типа стоимости в режим "По рецепту". Поле стоимости станет недоступным и отобразятся девять полей ингредиентов рецепта - "Слоты", поле "Количество продукта", поле "Модификации ингредиентов" и переключатель "Фильтр ингредиентов". Чтобы выбрать ингредиент начните заполнять наименование предмета (минимум три символа) и появится перечень доступных предметов из базы. Если в рецепте предмета уже сть ингредиенты, то список будет состоять из двух частей: "Ингредиенты" и "Поиск". Выберите интересующий Вас предмет из этого списка. Если ингредиент отсутствует в коллекции, то над полем будет располагаться кнопка "Добавить". Так же над полем ингредиента располагает иконка предмета и его стоимость. Если же предмет уже есть в коллекции, то вместо кнопки добавить будет кнопка "Редактировать". В выпадающем списке ингредиентов справа находится кнопка с иконкой крестика. Если Вы хотите чтобы предмет не отображался в списке ингредиентов, то нажмите на эту кнопку. Если Вы случайно скрыли нужный Вам ингредиент, то его можно отобразить. Для этого переключите поле "Фильтр ингредиентов" в положение "Выключен" и начните вводить в поле ингредиента нужный Вам предмет. Справа от скрытых ингредиентов будет кнопка с иконкой плюса, нажмите её для отображения соответствующего предмета. После выбора ингредиента над пустыми полями других ингредиентов рецепта справа появятся кнопки "Повторить". При нажатии на эту кнопку поле ингредиента под ней продублирует последний выбранный предмет. Чтобы добавить предмет, являющийся ингредиентом в рецепте, в коллекцию нажмите на кнопку "Добавить" и она сменится кнопкой "Редактировать". Если Вы нажмёте на кнопку "Редактировать" над ингредиентом, то перейдёте на страницу редактирования соответствующего предмета. Перед этим действием не забудьте сохранить изменения в настройках текущего предмета. Поле "Модификации ингредиентов" определяет из каких модификаций доступен выбор ингредиентов для рецепта. Вы можете добавить несколько модификаций или убрать текущие. Нельзя удалить модификацию, в том случае, если в ингредиентах находится хотя бы один из её предметов. Поле "Количество продукта" определяет количество предмета, получаемого из рецепта. Хоть текущие рецепты и допускают всего девять ингредиентов, но скомбинировав число ингредиентов и количество продукта, для некоторых случаев, можно рассчитать стоимость предмета состоящего и из большего количества ингредиентов. Например, для рецепта требуется какой-либо ингредиент в количестве 12 штук, в данном случае, можно описать расчёт его стоимости заполнив шесть полей ингредиентов и указав количество продукта равным 0,5. Если вы хотите вернуться к коллекции предметов, в случае если вы перешли на страницу редактирования со страницы коллекции, нажмите на кнопку "Назад". Если Вы заметили явную ошибку в рецепте по умолчанию и знаете правильный рецепт предмета (не обычную разновидность рецепта, а именно корректный рецепт аналогичный текущему), пожалуйста настройте корректный рецепт в своей коллекции, сохраните его и нажмите на кнопку "Предложить рецепт", которая находится правее кнопки удаления предмета.</p>
			</el-col>
		</el-row>	
	</div>		
</template>

<script>
import {db, removeItem, fFunctions, suggestRecipe} from '../firebase.js';
import {addItem} from '../functions.js';
export default {
  	data() {
	    return {
	    	itemsFilterVisibility: true,
	    	fileList: [],
	    	recipe: {},
	    	currentMods: [],
		   	icons: ['','','','','','','','',''],
		   	ingredients: ['','','','','','','','',''],
		   	rules: {},
	        loading: false,
	        form: {},
	        updatedParent: [],
	        updatedPath: [],
	        parentLength: 0,
	        displayName: '',
	        icon: '',
	        submitType: 'primary',
	        userCollection: [],
	        importRecipeGroup: [],
	        importRecipeStart: 0,
	        importHaveNextPage: true,
	        noImportRecipes: false,
	        ratingPath: '',
	        prevItem: {params:{item: ''}},
	        backSteps: -1,
	        filters: [],
	        baseHaveItem: false,
	        query: '',
	        lastpick: '',
	        startPrice: 0,
	    };
  	},
  	computed: {
  		itemCollection(){
  			var self = this;
  			var itemCollection = [];
			var currentMods = self.currentMods;
			var filter = self.$store.state.userOptions.itemsFilter || [];
			currentMods.forEach(function(el){
				itemCollection = itemCollection.concat(self.$store.state.itemCollection[el]);
			});
			itemCollection.forEach((el, i)=>{
				itemCollection[i].filterIcon = (filter.indexOf(el.name) == -1) ? 'close' : 'plus';
			});
			return itemCollection;
		},	
  		options(){
  			var self = this;
	    	var query = self.query;
	    	var itemCollection = self.itemCollection;
	    	var ingredients = self.ingredients;
	    	var options = [];
	    	var opt1 = [];
	    	var opt2 = [];
	    	var itemsFilter = self.$store.state.userOptions.itemsFilter || [];
        	if (query !== '' && query.length > 2) {
            	self.loading = false;
            	opt1 = itemCollection.filter(item => {
	        		if (item.displayName.toLowerCase().indexOf(query.toLowerCase()) > -1 && item.name != self.$route.params.item) {
	        			if (self.itemsFilterVisibility) {
	        				if (itemsFilter.indexOf(item.name) == -1) {
	        					return item;
	        				};
	        			} else {
	            			return item;
	        			};
	        		};
	        	});
	        };
        	opt2 = itemCollection.filter(function(el){
	        	return ingredients.indexOf(el.name) != -1;
	        });
	        if (opt2.length > 0) {
	        	options.push({
		    		label: 'Игридиенты',
		    		options: opt2,
	    		})
	        };
        	options.push({
	    		label: 'Поиск',
	    		options: opt1,
    		})
        	return options;
  		},
  		parentList(){
  			var self = this;
			var parentList = [];
			for (var prop in self.$store.state.userCollection) { 
	  			parentList = parentList.concat(self.$store.state.userCollection[prop].filter(el=>{
	  				for (var subProp in el.key) {
	  					if (el.key[subProp].item == self.$route.params.item) {
	  						return true;
	  					};
	  				};
	  			}));
	  		};
	  		return parentList;
  		},
  		visibilityImportButton(){
  			var self = this;
  			var baseHaveItem = false;
  			if (self.$store.state.itemCollection[self.recipe.mod]) {
	  			baseHaveItem = self.$store.state.itemCollection[self.recipe.mod].find(function(el){
	  				return el.name == self.$route.params.item && el.recipe.pattern != false;
	  			});
  			};
  			baseHaveItem = typeof baseHaveItem == 'object' ? true : false;
  			self.baseHaveItem = baseHaveItem;
  			return self.recipe.priceType == 'recipePrice' && !baseHaveItem;
  		},
  		params: function(){
  			var params = [];
  			var self = this;
  			this.ingredients.forEach(function(el, i){
  				if (el != null && el != ' ' && el != ''){
	  				var item = self.userCollection.find(function(subEl){
						return subEl.item == el;
					});
	  				if (item) {
	  					params[i] = {
		  					name: 'edit item',
		  					params: {
		  						item: el,
		  					},
		  				};
		  			} else {
		  				params[i] = false;
		  			};
	  			};
  			});
  			return params;
  		},
  		prices: function(){
  			var prices = ['','','','','','','','',''];
  			var self = this;
  			self.recipe.recipePrice = 0;
			this.ingredients.forEach(function(el, i){
	  			for (var prop in self.recipe.key) {
	  				if (self.recipe.key[prop].item == el) {
	  					var price = self.recipe.key[prop].price || 0;
	  					prices[i] = price;
	  					self.recipe.recipePrice += price;
	  				};
	  			};
			});
			self.recipe.recipePrice = (self.recipe.recipePrice / self.recipe.count).toFixed(1)*1;
  			return prices;
  		},
  	},
  	mounted(){
  		var self = this;
  		if (self.$route.params.item == undefined) {
  			self.$router.replace('/items');
  		} else {
			self.$store.subscribe((mutation, state) => {
		      	switch(mutation.type) {
		        	case 'updateUserCollection':
						self.setRecipes();
		        	break;
		      	};
		    });
			self.setRecipes();
		};
		self.filters = self.$store.state.filters;
		self.$store.subscribe((mutation, state) => {
	      	switch(mutation.type) {
	        	case 'updateFilters':
	        		self.filters = self.$store.state.filters;
	        	break;
	      	};
	    });
  	},
  	methods: {
  		addItemToFilter(item){
  			var self = this;
  			var itemsFilter = self.$store.state.userOptions.itemsFilter || [];
  			var index = itemsFilter.indexOf(item);
  			if (index == -1) {
  				itemsFilter.push(item);
  			} else {
				itemsFilter.splice(index, 1);
  			};
		    var data = {itemsFilter: itemsFilter};
	      	db.collection('users').doc(self.$store.state.user.uid).update(data).then(function(){
	        	self.$notify({title: 'Успех', message: 'Предмет добавлен в фильтр ингредиентов', type: 'success'});
	      	});
  		},
  		duplicate(index){
  			var self = this;
  			self.ingredients[index] = self.lastpick;
  			self.changeIngredient();
  		},
  		suggestRecipe: suggestRecipe,
  		back(){
  			var self = this;
  			if (self.prevItem.params.item == '' || self.prevItem.params.item == self.$route.params.item) {
				self.$router.go(self.backSteps);
  			} else {
				self.editItem(self.prevItem);
  				self.prevItem = {name: 'edit item', params: {item: self.$route.params.item}};
  			};
  		},
  		editItem(params) {
  			var self = this;
  			self.backSteps--;
  			self.prevItem = {name: 'edit item', params: {item: self.$route.params.item}};
  			self.$router.push(params);
  			self.setRecipes();
  			self.submitType = 'primary';
  		},
  		fileChange(file){
  			var self = this;
  			if (file.status == "success" || file.status == "ready") {
  				var image = new Image();
  				image.src = file.url;
  				image.onload = function(){
	  				var canvas = document.getElementById('recipe-canvas');
					var ctx = canvas.getContext('2d');
					ctx.imageSmoothingEnabled = false;
					var k = this.width > 150 ? 4 : 2;
					ctx.drawImage(this, 0, 0, Math.ceil(this.width/k), Math.ceil(this.height/k));
					var offsetY = 0;
					var offsetX = 0;
					for (var i = 0; i < this.height/4/k; i++) {
						var pixel = ctx.getImageData(Math.ceil(this.width/2/k), i, 1, 1);
						var data = pixel.data;
						var r = data[0], g = data[1], b = data[2];
						if (Math.abs(r - 199) < 10 && Math.abs(g - 199) < 10 && Math.abs(b - 199) < 10) {
							offsetY++;
						} else {break};
					};
					for (var i = 0; i < this.width/4/k; i++) {
						var pixel = ctx.getImageData(i, Math.ceil(this.height/2/k), 1, 1);
						var data = pixel.data;
						var r = data[0], g = data[1], b = data[2];
						if (Math.abs(r - 199) < 10 && Math.abs(g - 199) < 10 && Math.abs(b - 199) < 10) {
							offsetX++;
						} else {break};
					};
					ctx.drawImage(canvas, -offsetX, -offsetY);
					var points = [[1,1],[19,1],[37,1],[1,19],[19,19],[37,19],[1,37],[19,37],[37,37]];
					var datas = [];
					points.forEach((el)=>{
						datas.push(ctx.getImageData(el[0], el[1], 16, 16));
					});
					var minecraftImage = [];
					self.currentMods.forEach(el=>{
						self.$store.state.itemCollection[el].forEach(subEl=>{
							minecraftImage.push({url: subEl.image, name: subEl.displayName, item: subEl.name});
						});
					});
					var minecraftImageData = [];
					minecraftImage.forEach(el=>{
						var image = new Image();
						image.src = el.url;
						image.onload = function(){
							ctx.clearRect(0, 0, canvas.width, canvas.height);
							ctx.fillStyle = '#8c8c8c';
							ctx.fillRect(0, 0, 16, 16);
							ctx.drawImage(this, 0, 0);
							minecraftImageData.push({ctx: ctx.getImageData(0, 0, 16, 16), name: el.name, item: el.item});
							if (minecraftImageData.length == minecraftImage.length-1) {
								datas.forEach((el, i)=>{
									if (el.data.filter(subEl=>{return (subEl > 126 && subEl < 146) || (subEl == 255)}).length == el.data.length) {
										self.ingredients[i] = '';
									} else {
										function filtering(group, index, el){
											var newGroup = group.filter(subEl=>{
												return Math.abs(subEl.ctx.data[index]-el.data[index]) < 50;
											});
											if (newGroup.length > 1 && index < 1024){
												index = index + 32;
												filtering(newGroup, index, el);

											} else {
												group.forEach((subEl, i)=>{
													group[i].offset = 0;
													subEl.ctx.data.forEach((subSubEl, j)=>{
														group[i].offset += Math.abs(subSubEl-el.data[j]);
													});
												});
												group = group.find(el=>{
													return el.offset == group.map(subEl=>{
														return subEl.offset;
													}).sort((a, b)=>{return a - b;})[0];
												});
												self.ingredients[i] = group.item;
												self.changeIngredient();
											};
										};
										filtering(minecraftImageData, 0, el);
									};
								});
							};
						};
					});
  				};
  			};
  		},
  		changeRecipeOnImport(data){
  			var self = this;
			self.recipe.count = data.count;
			self.recipe.ingredients = data.ingredients;
			self.recipe.key = data.key;
			self.recipe.pattern = data.pattern;
			self.setOptionsByRecipe();
			self.ratingPath = data.path;
  		},
  		importRecipe(){
  			var self = this;
  			var size = 0;
  			db.collection('mods').doc(self.recipe.mod).collection('recipes').where("newRecipes", "array-contains", self.$route.params.item).orderBy("rating").startAt(self.importRecipeStart).limit(5).get().then(function(querySnapshot){
  				size = querySnapshot.size;
				querySnapshot.forEach(function(doc) {
					var data = doc.data();
					if (data.author != self.$store.state.user.uid) {
						var item = data[self.$route.params.item];
						self.importRecipeGroup.push({
							rating: data.rating,
							author: data.author,
							count: item.count,
							ingredients: item.ingredients,
							key: item.key,
							pattern: item.pattern,
							path: doc.ref.path,
						});
					};	
				});
				if (self.importRecipeGroup.length == 0) {
					self.noImportRecipes = true;
				};
				if (size == 5) {
					self.importRecipeStart += 5;
				} else {
					self.importHaveNextPage = false;	
				};
  			});
  		},
  		removeMod(mod){
  			var self = this;
  			var returnMod = false
  			self.ingredients.forEach(function(el){
  				if (el) {
	  				var item = self.itemCollection.find(function(subEl){
						return subEl.name == el;
					});
					if (item == undefined) {
						returnMod = true;
					} else {
						if (self.currentMods.indexOf(mod) == -1 && item.mod == mod) {
							returnMod = true;
						};	
					};
				};	
  			});
  			if (returnMod){
				self.currentMods.push(mod);
  			};
  		},
  		setOptionsByRecipe() {
  			var self = this;
			self.currentMods = [];
        	if (self.recipe.pattern){
	        	self.recipe.pattern.forEach(function(el, i){
	        		el.split('').forEach(function(el, j){
	        			if (el != ' ') {
	        				self.ingredients[i*3+j] = self.recipe.key[el].item;
    						var item = self.userCollection.find(function(subEl){
    							return subEl.item == self.recipe.key[el].item;
    						});
    						if (item) {
	        					var subRecipe = {
									item: item.item,
									price: item.price,
									ingredients: item.ingredients,
									pattern: item.pattern,
									key: item.key,
									count: item.count,
									customPrice: item.customPrice,
									recipePrice: item.recipePrice,
									priceType: item.priceType,
								};
	        					if (subRecipe != undefined) {
	        						self.recipe.key[el].price = subRecipe.priceType == 'customPrice' ? subRecipe.customPrice : subRecipe.recipePrice;
	        					};
	        					if (self.currentMods.indexOf(item.mod) == -1) {
	        						self.currentMods.push(item.mod);
	        					};
        					} else {
        						self.recipe.key[el].price = 0;
        						var item = self.$store.state.itemCollection[self.recipe.key[el].mod].find(function(subEl){return subEl.name == self.recipe.key[el].item});
        						if (self.currentMods.indexOf(item.mod) == -1) {
        							self.currentMods.push(item.mod);
        						};
        					};	
	        			};
	        		});
	        	});
	        };
			if (self.currentMods.length == 0) {
				self.$store.state.userCollection[self.recipe.mod].forEach(el=>{
					for (var prop in el.key) {
						if (self.currentMods.indexOf(el.key[prop].mod) == -1) {
							self.currentMods.push(el.key[prop].mod);
						};
					};					
				});
			};
        	self.setItemIcon();
  		},
  		setRecipes() {
  			var self = this;
  			self.icons = ['','','','','','','','',''];
  			self.ingredients = ['','','','','','','','',''];
  			var userID = this.$store.state.user;
  			self.userCollection = [];
  			for (var prop in self.$store.state.userCollection) {
  				self.userCollection = self.userCollection.concat(self.$store.state.userCollection[prop]);
  			};
			var item = self.userCollection.find(function(el){
				return el.item == self.$route.params.item;
			});
  			if (item) {
				self.recipe = {
					count: item.count,
					key: item.key,
					pattern: item.pattern,
					customPrice: item.customPrice,
					recipePrice: item.recipePrice,
					priceType: item.priceType,
					ingredients: item.ingredients,
					price: item.price,
					mod: item.mod,
					item: item.item,
				};
				self.startPrice = (self.recipe.priceType == 'recipePrice') ? self.recipe.recipePrice : self.recipe.customPrice;
				self.displayName = item.displayName;
				self.icon = item.image;
				self.setOptionsByRecipe();
		    } else if(self.$route.params.item && self.$route.params.mod) {
		    	self.$router.push({name: 'add item', params: {item: self.$route.params.item, mod: self.$route.params.mod}});
		    };
  		},
  		addItem: addItem,
  		addNewItem(i) {
  			var self = this;
  			var value = self.ingredients[i];
  			var item = self.itemCollection.find(function(el){return el.name == value});
  			self.addItem({item: value, mod: item.mod});
  		},
  		setItemIcon() {
  			var self = this;
  			self.icons = [];
  			self.ingredients.forEach(function(el){
  				var icon = self.itemCollection.filter(function(subEl){return subEl.name == el;});
  				icon = (icon.length > 0) ? icon[0].image : '';
  				self.icons.push(icon);
  			});
  		},
      	calculateParentPrice(item, newPrice, step){
      		var self = this;
      		var error = false;
      		self.parentLength++;
		    var docs = self.userCollection.filter(function(subEl){
				return subEl.ingredients.indexOf(item) > -1;
			});
			var docsChanged = self.updatedParent.filter(function(subEl){
				return subEl.recipe.ingredients.indexOf(item) > -1;
			});
			docsChanged.forEach(subEl=>{
				docs.forEach((subSubEl, i)=>{
					if (subSubEl.item == subEl.recipe.item) {
						docs[i]	= subEl.recipe;
					};
				});
			});
			step++;
			if (!(self.$route.params.item == item && self.startPrice == newPrice)) {
				docs.forEach(function(el) {
		            var recipe = {
						count: el.count,
						key: el.key,
						pattern: el.pattern,
						customPrice: el.customPrice,
						recipePrice: el.recipePrice,
						priceType: el.priceType,
						ingredients: el.ingredients,
						price: el.price,
						item: el.item,
						mod: el.mod,
					};
					var is_cyclical = false;
					self.updatedPath.forEach((subEl, i)=>{
						if (subEl.step == step && subEl.to == el.item && subEl.from == item) {
							if (i > 0) {
								var subItem = self.updatedPath[i-1];
								var duplicate = self.updatedPath.filter(subSubEl=>{
									return subSubEl.step == subItem.step && subSubEl.to == subItem.to && subSubEl.from == subItem.from;
								}).length > 1;
								if (duplicate) {
									is_cyclical = true;
								};
							};	
						};
					});
					self.updatedPath.push({from: item, to: el.item, step: step});
		            if (self.updatedParent.length < 1000 && self.recipe.ingredients.indexOf(recipe.item) == -1) {
			            for (var prop in recipe.key) {
			            	var price = recipe.key[prop].price || 0;
			            	recipe.key[prop].price = recipe.key[prop].item == item ? newPrice : price;
			            };
			            recipe.recipePrice = 0;
			            if (recipe.pattern){
				        	recipe.pattern.forEach(function(el){
				        		el.split('').forEach(function(el){
				        			if (el != ' ') {
				        				recipe.recipePrice += recipe.key[el].price;
				        			};
				        		});
				        	});
				        };
				        recipe.recipePrice = (recipe.recipePrice / recipe.count).toFixed(1)*1;
	      				self.updatedParent.push({recipe: recipe});
	      				if (recipe.priceType == 'recipePrice') {
							self.calculateParentPrice(recipe.item, recipe.recipePrice, step);
	      				} else {
	      				};
					} else {
						console.log(self.updatedParent.length);
						var displayName = self.$store.state.itemCollection[recipe.mod].find(el=>{return el.name == recipe.item}).displayName;
						self.$notify({title: 'Ошибка', message: 'При расчёте стоимости предмета <b>' + displayName + '</b> возникла зацикленность. Новые настройки не были сохранены. Проверьте текущий рецепт, а так же рецепты ингредиентов на ошибку зацикленности, поправьте её и попробуйте снова.', type: 'error', duration: 100000, dangerouslyUseHTMLString: true,});
	      				self.updatedPath = [];
						self.updatedParent = [];
						error = true;
					};
		        });
		    };    
	        self.parentLength--;
	        if (self.parentLength == 0 && !error) {
	        	var datas = {};
    			self.updatedParent.forEach(function(el){
			    	if (datas[el.recipe.mod] == undefined) {datas[el.recipe.mod] = {}};
			    	datas[el.recipe.mod][el.recipe.item] = {
			    		count: el.recipe.count,
						key: el.recipe.key,
						pattern: el.recipe.pattern,
						customPrice: el.recipe.customPrice,
						recipePrice: el.recipe.recipePrice,
						priceType: el.recipe.priceType,
						ingredients: el.recipe.ingredients,
						price: el.recipe.price,
						mod: el.recipe.mod,
			    	};
    			});
    			var datasSize = 0;
				var messagePart = '';
    			for (var prop in datas) {
    				for (var subProp in datas[prop]) {
    					var displayName = self.$store.state.itemCollection[prop].find(el=>{return el.name == subProp}).displayName;
    					messagePart += displayName + ', ';
    				};
    				datasSize++;
    				db.collection('mods').doc(prop).collection('recipes').doc(self.$store.state.user.uid).update(datas[prop]).then(function(){
    					datasSize--;
    					if (datasSize == 0) {
    						messagePart.slice(-1, 2);
    						self.$notify({title: 'Успех', message: 'Стоимость <b>' + messagePart + '</b> успешно обновлена', type: 'success', duration: 1000, dangerouslyUseHTMLString: true,});
    					};
					});
    			};
		    	if (self.visibilityImportButton) {
		    		var newRecipes = self.$store.state.newRecipes;
		    		if (newRecipes.indexOf(self.$route.params.item) == -1) {
		    			newRecipes.push(self.$route.params.item);
		    		};
		    		var data = {
		    			newRecipes: newRecipes,
		    		};
		    		db.collection('mods').doc(self.recipe.mod).collection('recipes').doc(self.$store.state.user.uid).update(data);
		    	}
		    	if (self.ratingPath != '') {
		    		var ratingIteration = fFunctions.httpsCallable('ratingIteration');
		    		ratingIteration({path: self.ratingPath}).then(function(result){});
		    	};
		    	self.updatedPath = [];
				self.updatedParent = [];
	        };
	        self.submitType = 'success';
		},
      	submitForm(formName, reset) {
      		var self = this;
        	this.$refs[formName].validate((valid) => {
	          	if (valid) {
        			self.recipe.recipePrice = self.recipe.recipePrice || 0;
        			var newPrice = self.recipe.priceType == 'customPrice' ? self.recipe.customPrice : self.recipe.recipePrice;
        			self.updatedParent.push({recipe: self.recipe});
        			self.calculateParentPrice(self.$route.params.item, newPrice, 0);
	          	};
        	});
      	},
  		removeItem: removeItem,
  		changeIngredient(e) {
  			var self = this;
  			if (e) {
  				self.lastpick = e;
  			};
			this.recipe.ingredients = _.uniq(this.ingredients).filter(function(el){
			  	return el != '' && el != null;
			});
        	this.recipe.pattern = ['', '', ''];
    		var keyS = ['a','b','c','d','e','f','g','h','i'];
        	this.ingredients.forEach(function(el, i){
        		var key = self.recipe.ingredients.indexOf(el);
        		key = (key == -1) ? ' ' : keyS[key];
        		self.recipe.pattern[Math.floor(i/3)] += key;
        	});
        	self.setItemIcon();
        	if (this.recipe.ingredients.length == 0) {
        		this.recipe.pattern = false;
        	};
        	this.recipe.key = {};
        	this.recipe.ingredients.forEach(function(el, i){
        		var price = 0;
				var item = self.userCollection.find(function(subEl){	
					return subEl.item == el;
				});
				if (item) {	
					price = item.priceType == 'customPrice' ? item.customPrice : item.recipePrice;
				};
				var mod = self.itemCollection.find(subEl=>{return subEl.name == el}).mod;
        		self.recipe.key[keyS[i]] = {
        			item: el,
        			price: price,
        			mod: mod,
        		};
        	});
  		},	
      	remoteMethod(query) {
      		var self = this;
      		self.query = query;
	    },
    },
};
</script>